import React, { Component } from 'react';
import { Button, Form, Loader, Popup, Table, Input, Select } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';

class StaffRole extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            roles: [],
            userTypeOptions: [],
            roleTypeOptions: []
        };
        this.getUserRoles = this.getUserRoles.bind(this);
        this.archiveRole = this.archiveRole.bind(this);
        this.addRole = this.addRole.bind(this);
        this.fetchUserTypeOptions = this.fetchUserTypeOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getUserRoles();
        this.fetchUserTypeOptions();
    }

    fetchUserTypeOptions() {
        axios.get('/user-types')
            .then(res => {
                this.setState({
                    userTypeOptions:
                        res.data ? res.data.map(el => ({
                            ...el, text: el.name, value: el._key, key: el._key
                        }))
                            : [],
                    loader: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch user types.');
            });
    }

    archiveRole(id) {
        let obj = { id };
        axios.put('user/archive-user-role', { ...obj })
            .then(res => {
                this.getUserRoles();
                toast('Uloga je uspješno arhivirana.');
            })
            .catch(err => {
                toast('Došlo je do greške. Uloga nije arhivirana.');
                console.log('Failed to archive user role.');
            });
    }

    addRole() {
        const organizationalUnitEmployeeId = localStorage.getItem('organizationalUnitEmployeeId');
        const { userType } = this.state;
        axios.post(`user/add-role-for-employee/${organizationalUnitEmployeeId}/${userType}`)
            .then(res => {
                this.setState({ newRole: false });
                this.getUserRoles();
                toast('Uspješno ste dodali ulogu.');
            })
            .catch(err => {
                if (err.response.data === 'This oue already has active role with passed key!') {
                    toast('Postoji već aktivna uloga.');
                } else if (err.response.data === 'Tried to create a role that already exists: ') {
                    toast('Postoji već aktivna uloga.');
                } else {
                    toast('Došlo je do greške. Uloga nije kreirana.');
                }
            });
    }

    activeRole(id) {
        let obj = { id };
        axios.put('user/unarchive-user-role', { ...obj })
            .then(res => {
                this.getUserRoles();
                toast('Uloga je uspješno aktivirana.');
            })
            .catch(err => {
                toast('Došlo je do greške. Uloga nije aktivirana.');
                console.log('Failed to archive user role.');
            });
    }

    getUserRoles() {
        const organizationalUnitEmployeeId = localStorage.getItem('organizationalUnitEmployeeId');
        this.setState({ loader: true });
        axios.get(`user/get-user-roles-for-oue/${organizationalUnitEmployeeId}`)
            .then(res => {
                this.setState({ roles: res.data ? res.data : [], loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch user roles.');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    render() {
        let {
            roles, loader, newRole, userTypeOptions, roleTypeOptions, roleName, roleNameErr, roleType, roleTypeErr
        } = this.state;
        return (
            loader ?
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                :
                <Table celled selectable compact size="small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                Naziv uloge
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Status uloge
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Datum kreiranja
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Datum arhiviranja
                            </Table.HeaderCell>
                            {(localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && <Table.HeaderCell verticalAlign="middle" textAlign="center" >
                                <Popup
                                    content="Dodaj ulogu"
                                    position="top center"
                                    trigger={
                                        <Button
                                            // disabled={disableAddButton}
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({ newRole: true })}
                                        />}
                                />
                            </Table.HeaderCell>}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.newRole && <Table.Row>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field
                                        required
                                        compact
                                        control={Select}
                                        clearable
                                        options={userTypeOptions.filter((e) => (e.key !== 3))}
                                        placeholder="Unesite naziv"
                                        onChange={this.handleInputChange}
                                        name="userType"
                                        value={roleName}
                                        error={roleNameErr}
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    {/* <Form.Field */}
                                    {/*    required */}
                                    {/*    compact */}
                                    {/*    control={Select} */}
                                    {/*    clearable */}
                                    {/*    options={roleTypeOptions.filter((e) => (e.value !== 3))} */}
                                    {/*    placeholder="Unesite tip" */}
                                    {/*    onChange={this.handleInputChange} */}
                                    {/*    name="roleType" */}
                                    {/*    value={roleType} */}
                                    {/*    error={roleTypeErr} */}
                                    {/* /> */}
                                    aktivna
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field required error={this.state.dateErr} disabled={!this.state.examTerm}>
                                        <DateTimePicker
                                            defaultValue={new Date()}
                                            format="D. M. YYYY. - HH:mm"
                                            timeFormat="HH:mm"
                                            onChange={this.handleChange.bind(null, 'date')}
                                            value={this.state.date}
                                            placeholder="Unesite datum u formatu D. M. GGGG."
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" />
                            <Table.Cell verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Potvrdi"
                                    position="top center"
                                    trigger={
                                        <Button
                                            basic="true"
                                            circular
                                            size="small"
                                            color="green"
                                            icon="check"
                                            onClick={() => this.addRole()}
                                        />}
                                />
                                <Popup
                                    content="Odustani"
                                    position="top center"
                                    trigger={
                                        <Button
                                            basic="true"
                                            circular
                                            size="small"
                                            color="red"
                                            icon="close"
                                            onClick={() => this.setState({ newRole: false })}
                                        />}
                                />

                            </Table.Cell>
                        </Table.Row>}
                        {roles.length ? roles.map((el, index) =>
                            (<Table.Row key={el.userRoleId}>
                                <Table.Cell verticalAlign="middle">
                                    {el.userTypeName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.archived ? 'arhivirana' : 'aktivna'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.createdOn ? moment(el.createdOn).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.dateOfArchiving ? moment(el.dateOfArchiving).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                {(localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Popup
                                        content="Arhiviraj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={el.archived}
                                                basic="true"
                                                circular
                                                size="small"
                                                color="red"
                                                icon="sign-out"
                                                onClick={() => this.archiveRole(el.userRoleId)}
                                            />
                                        }
                                    />
                                    <Popup
                                        content="Aktiviraj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={!el.archived}
                                                basic="true"
                                                circular
                                                size="small"
                                                color="green"
                                                icon="sign-out"
                                                onClick={() => this.activeRole(el.userRoleId)}
                                            />}
                                    />
                                </Table.Cell>}
                            </Table.Row>
                            )) : !newRole ? <h6><br /> Nema podataka.</h6> : null
                        }

                    </Table.Body>

                </Table>
        );
    }
}

export default StaffRole;



// WEBPACK FOOTER //
// ./src/views/Professor/StaffRole.js